import React from 'react';
import { TextFieldMenuDropdown } from '../text-field-menu-dropdown/text-field-menu-dropdown';
import { countries } from './countries';
import { CountryOption, CountySingleValue } from './text-field-menu-country-components';
import { filterOption } from '../../../../packages/pareto-style/select/select.utils';

const options = countries.map(country => ({
    value: country['alpha-3'],
    label: country.name,
    flag: country['alpha-2'],
}));

interface TextFieldMenuCountryProps {
    value:string;
    label:string;
    onChange: (value: string) => void;
    error:string;
    isDisabled?: boolean;
}

export const TextFieldMenuCountry = ({
    value,
    label,
    onChange,
    error,
    isDisabled,
}:TextFieldMenuCountryProps) => (
    <TextFieldMenuDropdown
        error={error}
        onChange={onChange}
        label={label}
        value={filterOption(value, options)}
        options={options}
        isDisabled={isDisabled}
        components={{
            Option: CountryOption,
            SingleValue: CountySingleValue,
        }}
    />
);
